export const setFocus = (ref) => { ref?.current && ref.current.focus(); };

export const setChildFocus = (ref, idx) => {
  (ref?.current && ref?.current?.children?.[idx]) && ref.current.children[idx].focus();
};
